module.exports = __webpack_public_path__ + "static/img/headimag2.b711a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/headimag2.jpg
// module id = gSMZ
// module chunks = 0